import Icons from "../../../../src/components/icons";
import * as React from 'react';
export default {
  Icons,
  React
};